module.exports = __webpack_public_path__ + "img/wp-new-habit-card17.72ed72c8.jpg";